import { SelectedContainersState } from "features/users/types";

export const generateContainers = (containersAmount: number) => {
  const limit = Math.min(containersAmount, 100);

  return Array.from({ length: limit }, (_, index) => ({
    value: `${index + 1}`,
    label: `Contenedor ${index + 1}`,
  }));
};

export const buildConfigs = (
  selectedContainers: SelectedContainersState,
): number[][] => {
  const session1Configs = Object.values(selectedContainers.session1)
    .filter(Boolean)
    .map(Number);

  const session2Configs = Object.values(selectedContainers.session2)
    .filter(Boolean)
    .map(Number);

  return [session1Configs, session2Configs];
};
